import { render, staticRenderFns } from "./LiveStats.vue?vue&type=template&id=1312953f&scoped=true&"
import script from "./LiveStats.vue?vue&type=script&lang=js&"
export * from "./LiveStats.vue?vue&type=script&lang=js&"
import style0 from "./LiveStats.vue?vue&type=style&index=0&id=1312953f&scoped=true&lang=css&"
import style1 from "./LiveStats.vue?vue&type=style&index=1&id=1312953f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1312953f",
  null
  
)

export default component.exports